type CssRules = Record<string, Record<string, string>>;

/**
 * Literal values for the Chargebee and Stripe payment iframes. Neither iframe
 * can read our CSS variables, so each build variant supplies its own hex values
 * in `#variant/helpers/paymentForm`.
 */
export type PaymentFormTheme = {
  /** Hex values of this build's `--gp-depth-0` … `--gp-depth-3` tokens. */
  depth: [string, string, string, string];
  accent: string;
  accentHover: string;
  /** Text on an accent fill: the pay button label. */
  onAccent: string;
  /** Accent wash of a method row, on hover and while it is open. */
  accentWash: { hover: string; open: string };
  text: string;
  mutedText: string;
  errorText: string;
  /** Fill and border of the payment form fields. */
  field: { background: string; border: string };
  fontFamily: string;
  /** Lettering of the pay button. */
  buttonLabel: { textTransform: string; letterSpacing: string };
  chargebee: {
    /** Extra style rules, merged per selector over the shared ones. */
    rules: CssRules;
  };
  /** Stripe Elements `appearance`. */
  stripeAppearance: Record<string, unknown>;
  /** Stripe Elements `fonts`: the iframe cannot use the page's fonts. */
  stripeFonts?: { cssSrc: string }[];
};

export function mergeCssRules(base: CssRules, extra: CssRules): CssRules {
  const merged = { ...base };
  for (const [selector, declarations] of Object.entries(extra)) {
    merged[selector] = { ...merged[selector], ...declarations };
  }
  return merged;
}
